import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const Companies = lazy(() => import('./companies'));

export function CompaniesPage() {
  return (
    <article className="space-y-6" data-testid="companies-page">
      <Suspense fallback={<Loading />}>
        <Companies />
      </Suspense>
    </article>
  );
}
